import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import { CheckboxWrapper, Input, Label, Square, Content } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CHECKMARK } from '../../icons/ICON_UI_CHECKMARK.js';

var _excluded = ["checked", "children", "className", "disabled", "onChange", "uniqueId", "fullWidthLabel", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? null : _ref$disabled,
    onChange = _ref.onChange,
    uniqueId = _ref.uniqueId,
    _ref$fullWidthLabel = _ref.fullWidthLabel,
    fullWidthLabel = _ref$fullWidthLabel === void 0 ? false : _ref$fullWidthLabel,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (typeof onChange !== 'function') {
    return false;
  }
  return /*#__PURE__*/jsxs(CheckboxWrapper, {
    className: className,
    style: style,
    children: [/*#__PURE__*/jsx(Input, _objectSpread({
      id: uniqueId,
      type: "checkbox"
      // @ts-ignore
      ,
      $disabled: disabled,
      onChange: !disabled ? onChange : null,
      "aria-checked": checked,
      "aria-disabled": disabled,
      readOnly: disabled,
      checked: checked,
      ref: ref
    }, rest)), /*#__PURE__*/jsxs(Label, {
      htmlFor: uniqueId
      // @ts-ignore
      ,
      $fullWidthLabel: fullWidthLabel,
      $disabled: disabled,
      children: [checked && /*#__PURE__*/jsx(Icon, {
        path: ICON_UI_CHECKMARK,
        className: "sg-checkbox-icon",
        size: "xxs"
      }), /*#__PURE__*/jsx(Square, {
        // @ts-ignore
        $disabled: disabled,
        $checked: checked
      }), children && /*#__PURE__*/jsx(Content, {
        // @ts-ignore
        $disabled: disabled,
        children: children
      })]
    })]
  });
});
Checkbox.displayName = 'Checkbox';
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
